import { getIn } from 'formik';

export function omitEmptyFields<T extends Record<string, unknown>>(values: T): T {
    const normalize = (v: unknown) => {
        if (typeof v === 'string') {
            const t = v.trim();
            return t === '' ? undefined : t;
        }
        return v;
    };

    return Object.fromEntries(
        Object.entries(values)
            .map(([k, v]) => [k, normalize(v)])
            .filter(([_, v]) => v !== undefined),
    ) as T;
}

export function isPathTouched(formik: { touched?: unknown }, path: string): boolean {
    const parts = path.split('.');

    for (let i = parts.length; i > 0; i--) {
        const parentPath = parts.slice(0, i).join('.');
        const touchedValue = getIn(formik.touched, parentPath);

        if (touchedValue === true) {
            return true;
        }

        if (touchedValue && typeof touchedValue === 'object') {
            return true;
        }
    }

    return false;
}

export function getErrorText(
    formik: { errors?: unknown; touched?: unknown },
    path: string,
): string | undefined {
    const value = getIn(formik.errors, path);
    const touched = isPathTouched(formik, path);

    return touched && value ? String(value) : undefined;
}
